export const WebConfig = {
  namespaced: true,
  state: {
    WebConfigState: 0,
  },
  mutations: {
    setWebConfigState(state, val) {
      state.WebConfigState = val;
    },
  },
};
